/**
 * Spiegelt API/AutoTransport.Domain/Enums/PlanRunStatus.cs. De numerieke waarden zijn positioneel:
 * wijzigt de backend-enum, dan moet deze mee.
 */
export enum PlanRunStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  /**
   * Door een planner afgebroken. Bewust naast Failed: er ging niets stuk, iemand vroeg erom — dus geen
   * foutmelding en geen "opnieuw proberen".
   */
  Cancelled = 4,
}
